// extracted by mini-css-extract-plugin
export default {"highlight":"nGon8BjxGk1nedAgjRpQ__highlight___","mention":"vstkKOZz_RDZemfMK5LW__mention___"};